<template>
  <main-layout
    class="pb-2"
    small
  >
    <sent-summary-container :intro="intro" />
  </main-layout>
</template>

<script>

import SentSummaryContainer from '@/components/Widgets/Drafts/SentSummaryContainer';

export default {

  name: 'SentDraft',
  components: {
    SentSummaryContainer,
  },
  data() {
    return {};
  },
  computed: {
    intro() {
      return this.$route.params.intro || false;
    },
  },
};
</script>

<style lang="css" scoped>
</style>
